import { Field, Form, Formik, } from 'formik';
import * as yup from 'yup';
import {
    Button,
    Stack,
    TextField,
    Typography,
    Checkbox,
    FormControl,
    FormGroup,
    FormControlLabel, } from '@mui/material';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { useSignup, } from '../hooks';
import SimpleBackdrop from '../components/simple-backdrop';

const initialValues = {
    email: '',
    displayName: '',
    password: '',
    confirmPassword: '',
    testData: true,
};

const validationSchema = yup.object({
    email: yup
        .string()
        .email('Неправильный формат email')
        .required('Вы должны заполнить email'),
    displayName: yup
        .string()
        .min(1, 'Имя пользователя должно состоять минимум из 1 символа')
        .max(50, 'Имя пользователя должно состоять не более чем из 50 символов')
        .required('Имя пользователя обязательно к заполнению'),
    password: yup
        .string()
        .min(6, 'Длина пароля должно состоять минимум из 6 символов')
        .max(25, 'Длина пароля должно состоять максимум из 25 символов')
        .required('Вы должны заполнить пароль'),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('password'), ''], 'Пароли должны совпадать').required('Вы должны заполнить пароль'),
});

export default function SignupPage() {
    const { signup, isPending, } = useSignup();

    const onSubmit = (formData) => {
        signup(formData);
    };

    return (
        <Stack
            direction='column'
            alignItems='center'
            sx={{
                mt: [3, 4, 5, 6],
                '& .MuiTextField-root': {
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'borderColor.main',
                        },
                        '&:hover fieldset': {
                            borderColor: 'secondary.main',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'secondary.main',
                        },
                    },
                    '& .MuiInputBase-input, & .MuiInputLabel-root': {
                        color: 'text.primary',
                    },
                },
            }}>
            <Stack
                direction='column'
                sx={{
                    bgcolor: (theme) => theme.palette.mode === 'light' ? 'grey.200' : 'common.shark',
                    borderRadius: 1,
                    boxShadow: 5,
                    p: [3, 3.75, 4.5, 5.25],
                    width: ['95%', '80%', '70%', '50%'],
                }}>
                <Stack
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    sx={{
                        mb: [3, 4, 5, 6],
                    }}>
                    <PersonAddAlt1Icon sx={{
                        color: 'text.primary',
                        fontSize: [29, 30, 31, 32],
                        mr: 1.25,
                    }} />
                    <Typography
                        component='h2'
                        sx={{
                            color: 'text.primary',
                            fontSize: [24, 25, 26, 27],
                            fontWeight: 700,
                        }}>
                        Регистрация
                    </Typography>
                </Stack>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={onSubmit}>
                    {
                        (formik) => {
                            return <Form autoComplete='off'>
                                <Field name='email'>
                                    {
                                        (props) => {
                                            const { field, meta: { error, touched, }, } = props;

                                            return <TextField
                                                {...field}
                                                color='secondary'
                                                fullWidth
                                                label='Введите email (без подтверждения)'
                                                error={touched && Boolean(error)}
                                                helperText={touched && error}
                                                sx={{mb: [2, 2, 3]}}
                                            />
                                        }
                                    }
                                </Field>
                                <Field name='displayName'>
                                    {
                                        (props) => {
                                            const { field, meta: { error, touched, }, } = props;

                                            return <TextField
                                                {...field}
                                                color='secondary'
                                                fullWidth
                                                label='Имя пользователя'
                                                error={touched && Boolean(error)}
                                                helperText={touched && error}
                                                sx={{mb: [2, 2, 3]}}
                                            />
                                        }
                                    }
                                </Field>
                                <Field name='password'>
                                    {
                                        (props) => {
                                            const { field, meta: { error, touched, }, } = props;

                                            return <TextField
                                                {...field}
                                                type='password'
                                                color='secondary'
                                                fullWidth
                                                label='Введите пароль'
                                                error={touched && Boolean(error)}
                                                helperText={touched && error}
                                                sx={{mb: [2, 2, 3]}}
                                            />
                                        }
                                    }
                                </Field>
                                <Field name='confirmPassword'>
                                    {
                                        (props) => {
                                            const { field, meta: { error, touched, }, } = props;

                                            return <TextField
                                                {...field}
                                                type='password'
                                                color='secondary'
                                                fullWidth
                                                label='Введите пароль повторно'
                                                error={touched && Boolean(error)}
                                                helperText={touched && error}
                                                sx={{mb: [2, 2, 3]}}
                                            />
                                        }
                                    }
                                </Field>
                                <Field name='testData' type='checkbox'>
                                    {
                                        (props) => {
                                            const { field, } = props;

                                            return <FormControl
                                                component='fieldset'
                                                sx={{mb: [4, 4, 6]}}>
                                                <FormGroup aria-label='position' row>
                                                    <FormControlLabel
                                                        label='Добавить тестовый контент (рекомендуется)'
                                                        labelPlacement='end'
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                color='secondary'
                                                                disableRipple
                                                                inputProps={{'aria-label': 'controlled',}}
                                                            />
                                                        }
                                                        sx={{color: 'text.primary'}}
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        }
                                    }
                                </Field>
                                <Stack direction='row' justifyContent='flex-end'>
                                    <Button
                                        type='submit'
                                        disabled={isPending || !formik.dirty}
                                        onClick={() => formik.validateForm()}
                                        sx={{
                                            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'common.rhino' : 'common.kashmirBlue',
                                            boxShadow: 2,
                                            color: 'common.white',
                                            py: 1,
                                            px: 1.5,
                                            width: {
                                                xs: '100%',
                                                sm: 'auto',
                                            },
                                            '&:hover': {
                                                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'common.rhino' : 'common.kashmirBlue',
                                            },
                                            '&:disabled': {
                                                color: 'rgba(255, 255, 255, 0.26)',
                                            },
                                        }}>{ isPending ? 'Регистрируемся...' : 'Зарегистрироваться' }</Button>
                                </Stack>
                            </Form>
                        }
                    }
                </Formik>
                <SimpleBackdrop open={isPending} />
            </Stack>
        </Stack>
    );
};